import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// -----------------签单管理------------------------------
// 新建签单
export const orderAdd = (data: Recordable) =>
  request.post('/crm/cps/ordersign/submit', data, jsonHeaderConfig)

// 签单详情
export const orderDetailGet = (data: Recordable) =>
  request.get('/crm/cps/ordersign/detail/' + data.id, data, jsonHeaderConfig)

// 模糊查询客户列表
export const getCustomerList = (data: any, options: Recordable) =>
  request.post('/crm/cps/ordersign/queryCustomers', data, options)

// 签单列表
export const orderListGet = (data: Recordable) =>
  request.post('/crm/cps/ordersign/list', data, jsonHeaderConfig)

// 签单删除
export const orderDelete = (data: Recordable) =>
  request.get('/crm/cps/ordersign/delete/' + data.id, data, jsonHeaderConfig)

// 签署合同预览
export const signContractPreview = (data: Recordable) =>
  request.post('/financial/credit/report/send_authorization_agreement', data, jsonHeaderConfig)

// 获取产品列表
export const getProductList = (data: Recordable) =>
  request.post('/financial/credit/report/query_product', data, jsonHeaderConfig)

// 新增进件
export const addInquiry = (data: Recordable) =>
  request.post('/crm/cps/loan/into', data, jsonHeaderConfig)

// 签单作废
export const orderInvalid = (data: Recordable) =>
  request.post('/crm/cps/ordersign/discard', data, jsonHeaderConfig)

//---------------------------------放款管理-----------------
// 放款列表
export const loanListGet = (data: Recordable) =>
  request.post('/crm/cps/loan/page', data, jsonHeaderConfig)

// 放款详情
export const loanDetailGet = (data: Recordable) =>
  request.post('/crm/cps/loan/detail', data, jsonHeaderConfig)

// 新增放款回执
export const addLoanReceipt = (data: Recordable) =>
  request.post('/crm/cps/loan/loan', data, jsonHeaderConfig)

// 新增回款记录
export const addRepaymentRecord = (data: Recordable) =>
  request.post('/crm/cps/loan/payment', data, jsonHeaderConfig)

// 删除放款
export const loanDelete = (data: Recordable) =>
  request.post('/crm/cps/loan/delete', data, jsonHeaderConfig)

// 放款详情编辑
export const loanDetailEdit = (data: Recordable) =>
  request.post('/crm/cps/loan/update', data, jsonHeaderConfig)

// 放款失败
export const loanFail = (data: Recordable) =>
  request.post('/crm/cps/loan/loan_fail', data, jsonHeaderConfig)

// ----------------------------------回访管理-------------------------------------
// 回访列表
export const visitListGet = (data: Recordable) =>
  request.post('/crm/customer/visit/back/listRecords', data, jsonHeaderConfig)

// 新增回访
export const addVisit = (data: Recordable) =>
  request.post('/crm/customer/visit/back/add_visit_back', data, jsonHeaderConfig)
// 获取回访记录
export const getVisitRecord = (data: Recordable) =>
  request.post('/crm/customer/visit/back/list', data, jsonHeaderConfig)

// 获取回访标签列表
export const getVisitLabelList = (data: Recordable) =>
  request.post('/crm/returnVistTag/list', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 该变标签
export const changeLabel = (data: Recordable) =>
  request.post('/crm/customer/visit/back/update_tags', data, jsonHeaderConfig)

// 通话记录列表
export const callRecordListGet = (data: Recordable) =>
  request.post('/call/callDetailRecord/returnVisitList', data, jsonHeaderConfig)

// 获取客户手机号
export const getPhone = (data: Recordable) =>
  request.get('/crm/track/normal/requireLinkPhone', data, jsonHeaderConfig)

//  补签单
export const repairSign = (data: Recordable) =>
  request.post('/crm/cps/ordersign/makeUp', data, jsonHeaderConfig)

// 回访详情分页
export const visitDetailGet = (data: Recordable) =>
  request.post('/crm/customer/visit/back/page', data, jsonHeaderConfig)
// 获取回访人列表
export const getVisitPersonList = (data: Recordable) =>
  request.post('/crm/customer/visit/back/list_visit_back_operators', data, jsonHeaderConfig, {
    ignoreCancelToken: true
  })

// 添加违规记录
export const addViolationRecord = (data: Recordable) =>
  request.post('/crm/cps/order/violation/add', data, jsonHeaderConfig)

// 违规记录列表
export const violationRecordListGet = (data: Recordable) =>
  request.post('/crm/cps/order/violation/list', data, jsonHeaderConfig)

// 根据客户id查询回访标签
export const getVisitLabelByCustomerId = (customerId: string) =>
  request.get(`crm/customer/visit/back/getTags/${customerId}`, null)
